// extracted by mini-css-extract-plugin
export var StyledImage = "StyledImage-module--StyledImage--A6ltp";
export var StyledImageFrameRight = "StyledImage-module--StyledImageFrameRight--3BLRG";
export var StyledImageFrameLeft = "StyledImage-module--StyledImageFrameLeft--2XKvn";